import { BreadcrumbNav } from "components/molecules";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  KualitasPewarnaanOptions,
  MonthOptions,
  PageMode,
} from "utils/constant";
import { useFormik } from "formik";
import moment from "moment";
import UjiSilangService from "services/UjiSilang";
import {
  errorToastNotif,
  getDataFromLocalStorage,
  successToastNotif,
} from "utils/common";
import InputDate from "components/atoms/InputDate";
import InputSelect from "components/atoms/InputSelect";
import InputField from "components/atoms/InputField";
import Button from "components/atoms/Button";
import { isValidRangeNumber } from "utils/helpers";
import InputCheckbox from "components/atoms/InputCheckbox";
import { toast } from "react-toastify";

const ujiSilangService = new UjiSilangService();

const Form = ({ pageMode, changeMode }) => {
  const [selectedItem, setSelectedItem] = useState(null);

  const { currentUser } = useSelector((state) => state.authReducer);

  const formik = useFormik({
    initialValues: {
      parasyte_benar: [],
      parasyte_palsu: [],
    },
    validate: (values) => {
      const errors = {};
      if (!isValidRangeNumber(values.nilai_pmbt_sd_tpis, 0, 100)) {
        errors.nilai_pmbt_sd_tpis = "Nilai harus antara 0 dan 100";
      }
      if (!isValidRangeNumber(values.nilai_pmbt_sd_tbal, 0, 100)) {
        errors.nilai_pmbt_sd_tbal = "Nilai harus antara 0 dan 100";
      }
      if (!isValidRangeNumber(values.jumsdneg_benar, 0, 999)) {
        errors.jumsdneg_benar = "Nilai harus antara 0 dan 999";
      }
      if (!isValidRangeNumber(values.jumsdneg_palsu, 0, 999)) {
        errors.jumsdneg_palsu = "Nilai harus antara 0 dan 999";
      }
      if (!isValidRangeNumber(values.jumsdpos_benar, 0, 999)) {
        errors.jumsdpos_benar = "Nilai harus antara 0 dan 999";
      }
      if (!isValidRangeNumber(values.jumsdpos_palsu, 0, 999)) {
        errors.jumsdpos_palsu = "Nilai harus antara 0 dan 999";
      }
      if (!isValidRangeNumber(values.jumpos_mix_benar, 0, 999)) {
        errors.jumpos_mix_benar = "Nilai harus antara 0 dan 999";
      }
      if (!isValidRangeNumber(values.jumpos_pf_benar, 0, 999)) {
        errors.jumpos_pf_benar = "Nilai harus antara 0 dan 999";
      }
      if (!isValidRangeNumber(values.jumpos_pv_benar, 0, 999)) {
        errors.jumpos_pv_benar = "Nilai harus antara 0 dan 999";
      }
      if (!isValidRangeNumber(values.jumpos_po_benar, 0, 999)) {
        errors.jumpos_po_benar = "Nilai harus antara 0 dan 999";
      }
      if (!isValidRangeNumber(values.jumpos_pm_benar, 0, 999)) {
        errors.jumpos_pm_benar = "Nilai harus antara 0 dan 999";
      }

      if (values.jumpos_mix_benar > 0 && !values.parasyte_benar?.length) {
        errors.parasyte = "Jenis parasit benar wajib diisi";
      }

      if (values.jumpos_mix_palsu > 0 && !values.parasyte_palsu?.length) {
        errors.parasyte = "Jenis parasit palsu wajib diisi";
      }

      if ([undefined, ""].includes(values.kualitas_pwrnaan_sd)) {
        errors.kualitas_pwrnaan_sd = "Kualitas pewarnaan wajib diisi";
      }

      const totpos_benar =
        +(values.jumpos_mix_benar ?? 0) +
          +(values.jumpos_pf_benar ?? 0) +
          +(values.jumpos_pv_benar ?? 0) +
          +(values.jumpos_po_benar ?? 0) +
          +(values.jumpos_pm_benar ?? 0) || 0;
      if (+(values.jumsdpos_benar ?? 0) < totpos_benar) {
        errors.jumsdpos_benar = `Jumlah sedian darah tidak boleh lebih dari positif benar (> ${values.jumsdpos_benar})`;
      }

      const totpos_palsu =
        +(values.jumpos_mix_palsu ?? 0) +
          +(values.jumpos_pf_palsu ?? 0) +
          +(values.jumpos_pv_palsu ?? 0) +
          +(values.jumpos_po_palsu ?? 0) +
          +(values.jumpos_pm_palsu ?? 0) || 0;
      if (+(values.jumsdpos_palsu ?? 0) < totpos_palsu) {
        errors.jumsdpos_palsu = `Jumlah sedian darah tidak boleh lebih dari positif palsu (> ${values.jumsdpos_palsu})`;
      }

      return errors;
    },
    onSubmit: async (values) => {
      let payload = {
        ...values,
        kdkab_val: currentUser?.district_id.split("|")[0],
        tglsimpan_kab: moment().format("YYYY-MM-DD"),
        totpos_benar:
          +values.jumpos_mix_benar +
            +values.jumpos_pf_benar +
            +values.jumpos_pv_benar +
            +values.jumpos_po_benar +
            +values.jumpos_pm_benar || 0,
        totpos_palsu:
          +values.jumpos_mix_palsu +
            +values.jumpos_pf_palsu +
            +values.jumpos_pv_palsu +
            +values.jumpos_po_palsu +
            +values.jumpos_pm_palsu || 0,
      };

      const totpos =
        +payload.jumsdneg_benar +
        +payload.jumsdneg_palsu +
        +payload.jumsdpos_benar +
        +payload.jumsdpos_palsu;
      if (totpos !== payload.jumsdfaskes) {
        return toast.error(
          `Jumlah sedian darah harus sama dengan jumlah total positif dan negatif (= ${payload.jumsdfaskes})`,
          {
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          }
        );
      }

      switch (pageMode) {
        case PageMode.add:
        case PageMode.edit:
          await ujiSilangService
            .update(payload, selectedItem?.id)
            .then((res) => {
              changeMode(PageMode.view);
              successToastNotif("Data berhasil diperbarui");
            })
            .catch((err) => {
              console.log(err);
              errorToastNotif(err);
            });
          break;
      }
    },
  });

  useEffect(() => {
    if (pageMode === PageMode.edit) {
      const dataFromStorage = JSON.parse(
        getDataFromLocalStorage("SELECTED_ITEM")
      );

      setSelectedItem(dataFromStorage);
      formik.setValues({ ...dataFromStorage });
    }
  }, []);

  const errorJumsdposBenar = formik.errors.jumsdpos_benar;
  const errorJumsdposPalsu = formik.errors.jumsdpos_palsu;

  return (
    <>
      <BreadcrumbNav
        items={[
          {
            label: "Uji Silang Kab/Kota",
            onClick: () => changeMode(PageMode.view),
          },
          {
            label:
              pageMode === PageMode.add
                ? "Tambah Data Uji Silang Kab/Kota"
                : "Edit Data Uji Silang Kab/Kota",
          },
        ]}
      />
      <h1 className="page-title">
        {pageMode === PageMode.add
          ? "Tambah Data Uji Silang Kab/Kota"
          : "Edit Data Uji Silang Kab/Kota"}
      </h1>
      {/* Informasi wilayah */}
      <div className="informasi-wilayah">
        <section className="list-item">
          <p className="item-label">Provinsi</p>
          <p className="item-value">
            {currentUser?.province_id?.split("|")[1]}
          </p>
        </section>
        <hr />
        <section className="list-item">
          <p className="item-label">Kab/Kota</p>
          <p className="item-value">
            {currentUser?.district_id?.split("|")[1]}
          </p>
        </section>
        <hr />
        <section className="list-item">
          <p className="item-label">Fasyankes</p>
          <p className="item-value">
            {formik.values?.fasyankes_id?.split("|")[1]}
          </p>
        </section>
      </div>

      <div className="form-grouping">
        <p className="warning" style={{ marginBottom: "24px" }}>
          NOTE: <span>* WAJIB DIISI</span>
        </p>

        <div className="grid grid-cols-3 gap-4">
          <InputDate
            label={"Tahun"}
            name={"year"}
            placeholder={"Pilih tahun"}
            dateFormat={"YYYY"}
            onChange={(e) => {
              const selectedYear = moment(e).format("YYYY");
              formik.handleChange("year")(selectedYear);
            }}
            onBlur={formik.handleBlur}
            value={formik.values.year}
            error={formik.errors.year && formik.touched.year}
            errorMessage={formik.errors.year}
            isRequired={true}
            isDisabled
          />
          <InputSelect
            label={"Bulan"}
            name={"month"}
            placeholder={"Pilih bulan"}
            data={MonthOptions}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              formik.handleChange("month")(selectedValue);
            }}
            onBlur={formik.handleBlur}
            value={MonthOptions.find(
              (item) => item.value === formik.values.month
            )}
            error={formik.errors.month && formik.touched.month}
            errorMessage={formik.errors.month}
            isRequired={true}
            isDisabled
          />
          <InputField
            label={"Jumlah (Sedian Darah=SD)"}
            name={"jumsdfaskes"}
            type={"number"}
            maxLengthVal={3}
            {...formik.getFieldProps("jumsdfaskes")}
            error={formik.errors.jumsdfaskes && formik.touched.jumsdfaskes}
            errorMessage={formik.errors.jumsdfaskes}
            isRequired={true}
            disabled
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <InputField
            label={"Nilai pembuatan SD tipis (0-100%)"}
            name={"nilai_pmbt_sd_tpis"}
            type={"number"}
            maxLengthVal={3}
            placeholder={"Masukkan nilai pembuatan SD tipis "}
            {...formik.getFieldProps("nilai_pmbt_sd_tpis")}
            error={
              formik.errors.nilai_pmbt_sd_tpis &&
              formik.touched.nilai_pmbt_sd_tpis
            }
            errorMessage={formik.errors.nilai_pmbt_sd_tpis}
            isRequired={true}
            max={100}
          />
          <InputField
            label={"Nilai pembuatan SD tebal tidak terfiksasi (0-100%)"}
            name={"nilai_pmbt_sd_tbal"}
            type={"number"}
            maxLengthVal={3}
            placeholder={"Masukkan nilai pembuatan SD tebal tidak terfiksasi"}
            {...formik.getFieldProps("nilai_pmbt_sd_tbal")}
            error={
              formik.errors.nilai_pmbt_sd_tbal &&
              formik.touched.nilai_pmbt_sd_tbal
            }
            errorMessage={formik.errors.nilai_pmbt_sd_tbal}
            isRequired={true}
            max={100}
          />
          <InputSelect
            label={"Kualitas pewarnaan"}
            name={"kualitas_pwrnaan_sd"}
            placeholder={"Pilih kualitas pewarnaan"}
            data={KualitasPewarnaanOptions}
            onChange={(e) => {
              const selectedValue = e ? e.value : "";
              formik.handleChange("kualitas_pwrnaan_sd")(selectedValue);
            }}
            onBlur={formik.handleBlur}
            value={KualitasPewarnaanOptions.find(
              (item) => item.value === formik.values.kualitas_pwrnaan_sd
            )}
            error={
              formik.errors.kualitas_pwrnaan_sd &&
              formik.touched.kualitas_pwrnaan_sd
            }
            errorMessage={formik.errors.kualitas_pwrnaan_sd}
            isRequired={true}
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <InputDate
            label={"Tanggal Sampel Dikirim"}
            name={"tgl_sampel_dikirim"}
            placeholder={"Pilih tanggal"}
            dateFormat={"YYYY-MM-DD"}
            onChange={(e) => {
              const selectedDate = e ? moment(e).format("YYYY-MM-DD") : "";
              formik.handleChange("tgl_sampel_dikirim")(selectedDate);
            }}
            onBlur={formik.handleBlur}
            value={formik.values.tgl_sampel_dikirim}
            error={
              formik.errors.tgl_sampel_dikirim &&
              formik.touched.tgl_sampel_dikirim
            }
            errorMessage={formik.errors.tgl_sampel_dikirim}
            isRequired={true}
          />
        </div>
        <div className="grid grid-cols-2 gap-4">
          <InputField
            label={"Negatif benar (0-999)"}
            name={"jumsdneg_benar"}
            type={"number"}
            maxLengthVal={3}
            placeholder={"Masukkan negatif benar"}
            {...formik.getFieldProps("jumsdneg_benar")}
            error={
              formik.errors.jumsdneg_benar && formik.touched.jumsdneg_benar
            }
            errorMessage={formik.errors.jumsdneg_benar}
            isRequired={true}
          />
          <InputField
            label={"Negatif palsu (0-999)"}
            name={"jumsdneg_palsu"}
            type={"number"}
            maxLengthVal={3}
            placeholder={"Masukkan negatif palsu"}
            {...formik.getFieldProps("jumsdneg_palsu")}
            error={
              formik.errors.jumsdneg_palsu && formik.touched.jumsdneg_palsu
            }
            errorMessage={formik.errors.jumsdneg_palsu}
            isRequired={true}
          />
        </div>
        <InputField
          label={"Positif benar (0-999)"}
          name={"jumsdpos_benar"}
          type={"number"}
          maxLengthVal={3}
          placeholder={"Masukkan positif benar"}
          {...formik.getFieldProps("jumsdpos_benar")}
          onChange={(v) => {
            formik.getFieldProps("jumsdpos_benar").onChange(v);
            if (Number(v.target.value) === 0) {
              formik.setFieldValue("jumpos_mix_benar", 0);
              formik.setFieldValue("jumpos_pf_benar", 0);
              formik.setFieldValue("jumpos_pv_benar", 0);
              formik.setFieldValue("jumpos_po_benar", 0);
              formik.setFieldValue("jumpos_pm_benar", 0);
              formik.setFieldValue("parasyte_benar", []);
            }
          }}
          isRequired={true}
        />

        {Number(formik.values.jumsdpos_benar) > 0 && (
          <div
            className="grid grid-cols-2 gap-4"
            style={{
              border: `1px solid ${errorJumsdposBenar ? "red" : "#ccc"}`,
              padding: "16px",
              borderRadius: "8px",
            }}
          >
            {errorJumsdposBenar && (
              <span className="col-span-2 error">
                {formik.errors.jumsdpos_benar}
              </span>
            )}
            <InputField
              label={"Jumlah sedian darah positif (mix spesies benar) 0-999"}
              name={"jumpos_mix_benar"}
              type={"number"}
              maxLengthVal={3}
              placeholder={
                "Masukkan jumlah sedian darah positif (mix spesies benar)"
              }
              {...formik.getFieldProps("jumpos_mix_benar")}
              error={
                formik.errors.jumpos_mix_benar &&
                formik.touched.jumpos_mix_benar
              }
              errorMessage={formik.errors.jumpos_mix_benar}
              isRequired={true}
            />
            {Number(formik.values.jumpos_mix_benar) > 0 && (
              <InputCheckbox
                label="Jenis parasit benar"
                name="parasyte_benar"
                options={[
                  { label: "P.falciparum", value: "P.Falciparum" },
                  { label: "P.malariae", value: "P.Malariae" },
                  { label: "Probable knowlesi", value: "Probable Knowlesi" },
                  { label: "P.vivax", value: "P.Vivax" },
                  { label: "P.ovale", value: "P.Ovale" },
                ]}
                {...formik.getFieldProps("parasyte_benar")}
                selectedOption={formik.values.parasyte_benar}
                isItalic={true}
                error={
                  formik.errors.parasyte_benar && formik.touched.parasyte_benar
                }
                errorMessage={formik.errors.parasyte_benar}
                isRequired={true}
                className="grid grid-cols-3 gap-1"
              />
            )}
            <InputField
              label={"Jumlah sedian darah positif (pf spesies benar) 0-999"}
              name={"jumpos_pf_benar"}
              type={"number"}
              maxLengthVal={3}
              placeholder={
                "Masukkan jumlah sedian darah positif (pf spesies benar)"
              }
              {...formik.getFieldProps("jumpos_pf_benar")}
              error={
                formik.errors.jumpos_pf_benar && formik.touched.jumpos_pf_benar
              }
              errorMessage={formik.errors.jumpos_pf_benar}
              isRequired={true}
            />
            <InputField
              label={"Jumlah sedian darah positif (pv spesies benar) 0-999"}
              name={"jumpos_pv_benar"}
              type={"number"}
              maxLengthVal={3}
              placeholder={
                "Masukkan jumlah sedian darah positif (pv spesies benar)"
              }
              {...formik.getFieldProps("jumpos_pv_benar")}
              error={
                formik.errors.jumpos_pv_benar && formik.touched.jumpos_pv_benar
              }
              errorMessage={formik.errors.jumpos_pv_benar}
              isRequired={true}
            />
            <InputField
              label={"Jumlah sedian darah positif (po spesies benar) 0-999"}
              name={"jumpos_po_benar"}
              type={"number"}
              maxLengthVal={3}
              placeholder={
                "Masukkan jumlah sedian darah positif (po spesies benar)"
              }
              {...formik.getFieldProps("jumpos_po_benar")}
              error={
                formik.errors.jumpos_po_benar && formik.touched.jumpos_po_benar
              }
              errorMessage={formik.errors.jumpos_po_benar}
              isRequired={true}
            />
            <InputField
              label={"Jumlah sedian darah positif (pm spesies benar) 0-999"}
              name={"jumpos_pm_benar"}
              type={"number"}
              maxLengthVal={3}
              placeholder={
                "Masukkan jumlah sedian darah positif (pm spesies benar)"
              }
              {...formik.getFieldProps("jumpos_pm_benar")}
              error={
                formik.errors.jumpos_pm_benar && formik.touched.jumpos_pm_benar
              }
              errorMessage={formik.errors.jumpos_pm_benar}
              isRequired={true}
            />
          </div>
        )}

        <InputField
          label={"Positif Palsu (0-999)"}
          name={"jumsdpos_palsu"}
          type={"number"}
          maxLengthVal={3}
          placeholder={"Masukkan Positif Palsu"}
          {...formik.getFieldProps("jumsdpos_palsu")}
          onChange={(v) => {
            formik.getFieldProps("jumsdpos_palsu").onChange(v);
            if (Number(v.target.value) === 0) {
              formik.setFieldValue("jumpos_mix_palsu", 0);
              formik.setFieldValue("jumpos_pf_palsu", 0);
              formik.setFieldValue("jumpos_pv_palsu", 0);
              formik.setFieldValue("jumpos_po_palsu", 0);
              formik.setFieldValue("jumpos_pm_palsu", 0);
              formik.setFieldValue("parasyte_palsu", []);
            }
          }}
          isRequired={true}
        />

        {Number(formik.values.jumsdpos_palsu) > 0 && (
          <div
            className="grid grid-cols-2 gap-4"
            style={{
              border: `1px solid ${errorJumsdposPalsu ? "red" : "#ccc"}`,
              padding: "16px",
              borderRadius: "8px",
            }}
          >
            {errorJumsdposPalsu && (
              <span className="col-span-2 error">
                {formik.errors.jumsdpos_palsu}
              </span>
            )}
            <InputField
              label={"Jumlah sedian darah positif (mix spesies palsu) 0-999"}
              name={"jumpos_mix_palsu"}
              type={"number"}
              maxLengthVal={3}
              placeholder={
                "Masukkan jumlah sedian darah positif (mix spesies palsu)"
              }
              {...formik.getFieldProps("jumpos_mix_palsu")}
              error={
                formik.errors.jumpos_mix_palsu &&
                formik.touched.jumpos_mix_palsu
              }
              errorMessage={formik.errors.jumpos_mix_palsu}
              isRequired={true}
            />
            {Number(formik.values.jumpos_mix_palsu) > 0 && (
              <InputCheckbox
                label="Jenis parasit palsu"
                name="parasyte_palsu"
                options={[
                  { label: "P.falciparum", value: "P.Falciparum" },
                  { label: "P.malariae", value: "P.Malariae" },
                  { label: "Probable knowlesi", value: "Probable Knowlesi" },
                  { label: "P.vivax", value: "P.Vivax" },
                  { label: "P.ovale", value: "P.Ovale" },
                ]}
                {...formik.getFieldProps("parasyte_palsu")}
                selectedOption={formik.values.parasyte_palsu}
                isItalic={true}
                error={
                  formik.errors.parasyte_palsu && formik.touched.parasyte_palsu
                }
                errorMessage={formik.errors.parasyte_palsu}
                isRequired={true}
                className="grid grid-cols-3 gap-1"
              />
            )}
            <InputField
              label={"Jumlah sedian darah positif (pf spesies palsu) 0-999"}
              name={"jumpos_pf_palsu"}
              type={"number"}
              maxLengthVal={3}
              placeholder={
                "Masukkan jumlah sedian darah positif (pf spesies palsu)"
              }
              {...formik.getFieldProps("jumpos_pf_palsu")}
              error={
                formik.errors.jumpos_pf_palsu && formik.touched.jumpos_pf_palsu
              }
              errorMessage={formik.errors.jumpos_pf_palsu}
              isRequired={true}
            />
            <InputField
              label={"Jumlah sedian darah positif (pv spesies palsu) 0-999"}
              name={"jumpos_pv_palsu"}
              type={"number"}
              maxLengthVal={3}
              placeholder={
                "Masukkan jumlah sedian darah positif (pv spesies palsu)"
              }
              {...formik.getFieldProps("jumpos_pv_palsu")}
              error={
                formik.errors.jumpos_pv_palsu && formik.touched.jumpos_pv_palsu
              }
              errorMessage={formik.errors.jumpos_pv_palsu}
              isRequired={true}
            />
            <InputField
              label={"Jumlah sedian darah positif (po spesies palsu) 0-999"}
              name={"jumpos_po_palsu"}
              type={"number"}
              maxLengthVal={3}
              placeholder={
                "Masukkan jumlah sedian darah positif (po spesies palsu)"
              }
              {...formik.getFieldProps("jumpos_po_palsu")}
              error={
                formik.errors.jumpos_po_palsu && formik.touched.jumpos_po_palsu
              }
              errorMessage={formik.errors.jumpos_po_palsu}
              isRequired={true}
            />
            <InputField
              label={"Jumlah sedian darah positif (pm spesies palsu) 0-999"}
              name={"jumpos_pm_palsu"}
              type={"number"}
              maxLengthVal={3}
              placeholder={
                "Masukkan jumlah sedian darah positif (pm spesies palsu)"
              }
              {...formik.getFieldProps("jumpos_pm_palsu")}
              error={
                formik.errors.jumpos_pm_palsu && formik.touched.jumpos_pm_palsu
              }
              errorMessage={formik.errors.jumpos_pm_palsu}
              isRequired={true}
            />
          </div>
        )}

        <div className="form_action">
          <Button
            variant={"tertiary"}
            size={"normal"}
            onClick={() => changeMode(PageMode.view)}
          >
            Batalkan
          </Button>
          <Button
            variant={"primary"}
            size={"normal"}
            type="button"
            onClick={formik.handleSubmit}
            isDisabled={formik.isSubmitting || !formik.isValid || !formik.dirty}
          >
            Simpan Data
          </Button>
        </div>
      </div>
    </>
  );
};

export default Form;
